function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "lk4m46ctua",
  d: "M0 6c0 3.314 2.686 6 6 6s6-2.686 6-6-2.686-6-6-6-6 2.686-6 6z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-927.000000, -288.000000) translate(927.000000, 288.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "p5frusmvwb",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#lk4m46ctua"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#DA251C",
  d: "M8.133 12.4L12.4 12.4 12.4 -0.4 8.133 -0.4z",
  mask: "url(#p5frusmvwb)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M3.867 12.4L8.133 12.4 8.133 -0.4 3.867 -0.4z",
  mask: "url(#p5frusmvwb)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1A3785",
  d: "M-0.4 12.4L3.867 12.4 3.867 -0.4 -0.4 -0.4z",
  mask: "url(#p5frusmvwb)"
}))));

function SvgFr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFr);
export default __webpack_public_path__ + "static/media/fr.6b2f424f.svg";
export { ForwardRef as ReactComponent };